<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg box1 zt">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" @timeChange="timeChange">
          </time-search>
        </div>
        <div class="dbTime dn-content-bg">
          <label class="jg">对比时间:</label>
          <el-checkbox v-model="timeOne" class="jg">对比时间1:</el-checkbox>
          <el-date-picker class="jg" v-model="valueOne" :type="timeType" @change="changetime1" placeholder="选择时间">
          </el-date-picker>
          <!-- :format="timeType=='date'?'yyyy-MM-dd':timeType=='month'?'yyyy-MM-dd':'yyyy'" -->
          <el-checkbox v-model="timeTwo" class="jg">对比时间2:</el-checkbox>
          <el-date-picker @change="changetime2" class="jg" v-model="valueTwo" :type="timeType" placeholder="选择时间">
          </el-date-picker>
          <el-button style="height: 30px;line-height: 0px;" ref="print" type="primary" class="btn" @click="match">开始比对</el-button>
        </div>
        <div class="tab-pane ">
          <div class="tap-echarts ">
            <div class="dn-title-bg tab-top zt">
              <i class="iconfont  icon-youxiang" style="margin-right:5px"></i>
              用电量对比
            </div>
            <div class="tap-center dn-content-bg">
              <div class="echarts">
                <echarts :echartsData="echartsData" :direction="'top'"></echarts>
              </div>
            </div>
          </div>
          <div class="tables table-content dn-content-bg">
            <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true">
            </nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import { findDataByParam } from '@/utils/index.js'
import * as utils from '@/utils/index.js'
import echarts from './pages/echarts.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import TabTree from '@/components/common/TabTree.vue'
import handleData from '@/utils/handleData.js'
import dateTool from '@/utils/dateTool'
import NkTable from '@/components/common/NkTable'
import BtnShow from '@/components/common/BtnShow.vue'
import ResizeContainer from '@/components/common/resizeContainer.vue'
import { isNull, isUndefined } from 'util'
let allTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  {
    type: 'year',
    label: '年',
  },
]
export default {
  components: {
    TimeSearch,
    TabTree,
    echarts,
    NkTable,
    BtnShow,
    ResizeContainer,
  },
  data () {
    return {
      tabShow: true,
      viewTreeData: [],
      timeData: allTimeData,
      columns: [],
      tableData: [],
      selectedDate: {
        dateType: 'day',
        startTime: '',
        endTime: '',
      },
      timeOne: false,
      timeTwo: false,
      valueOne: '',
      valueTwo: '',
      timeType: 'month',
      echartsData: {},
      dateType: 'day',
      pointInfo: {
        pointNumber: '0',
        pointCode: '100229',
      },
    }
  },
  created () { },
  watch: {},
  activated () { },
  methods: {
    changeCompany (companyId) {
      let vm = this
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/nygl/toAndFormNh2', null)
        .then((res) => {
          if (res) {
            const viewTreeData = findDataByParam('viewTree', true, res.data)
            vm.viewTreeData = viewTreeData
          }
        })
    },
    /* 树加载 */
    tabTreeDefault (e) {
      this.selectNodes = [e]
      let time = new Date()
      let startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
      time.setDate(time.getDate() + 1)
      let endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
      /* valueOne */
      time.setDate(time.getDate() - 2)
      this.valueOne = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
      /* valueTwo */
      time.setDate(time.getDate() + 2)
      this.valueTwo = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
      this.selectedDate = {
        dataType: '1',
        dateType: 'day',
        startTime: startTime,
        endTime: endTime,
      }
      this.TimeControlClick(this.selectedDate)
    },
    /* 树点击 */
    tabTreeClick (e) {
      this.selectNodes = [e]
      this.TimeControlClick(this.selectedDate)
    },
    /* 比对时间一 */
    changetime1 (e) {
      let time = new Date(e)
      if (this.timeOne) {
        this.matchTimeOne(time, this.valueOne, this.valueTwo, 'one')
      }
    },
    /* 比对时间二 */
    changetime2 (e) {
      let time = new Date(e)
      if (this.timeTwo) {
        this.matchTimeOne(time, this.valueTwo, this.valueOne, 'two')
      }
    },
    /* 匹配时间  time时间  timeOne綁定的是valueOne还是valueTwo */
    matchTimeOne (time, timeOne, timeTwo, type) {
      if (this.dateType == 'day') {
        timeOne = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
      } else if (this.dateType == 'month') {
        timeOne = dateTool.format(time, 'yyyy-MM-') + '01 00:00:00'
      } else {
        timeOne = dateTool.format(time, 'yyyy-') + '01-01 00:00:00'
      }
      if (type == 'one') {
        this.valueOne = timeOne
      } else {
        this.valueTwo = timeOne
      }
    },
    timeControlChange (e) {
      this.dateType = e.dateType
      this.timeType = e.dateType
      if (e.dateType == 'day') {
        this.timeType = 'date'
      }
    },
    /* 时间发生改变 */
    timeChange (e) {
      this.selectedDate = e
    },
    /* 开始比对 */
    match () {
      this.changetime1(this.valueOne)
      this.changetime2(this.valueTwo)
      this.getData()
    },
    /* 查询 */
    TimeControlClick (e) {
      this.selectedDate = e
      this.dateType = e.dateType
      this.changetime1(this.valueOne)
      this.changetime2(this.valueTwo)
      this.getData()
    },
    async getData () {
      let vm = this
      let measureStr = []
      let dataStr = [vm.selectedDate.startTime]
      if (vm.timeOne) {
        dataStr.push(vm.valueOne)
      }
      if (vm.timeTwo) {
        dataStr.push(vm.valueTwo)
      }
      dataStr = Array.from(new Set(dataStr))
      vm.selectNodes.forEach((item) => {
        measureStr.push({
          measureId: item.measureId,
          pointNumber: vm.pointInfo.pointNumber,
          pointCode: vm.pointInfo.pointCode,
        })
      })
      let res = await vm.$api.tmp.getEnergyAnalysisOfWorkingTime(
        JSON.stringify(measureStr),
        JSON.stringify(dataStr),
        vm.selectedDate.dateType
      )
      let obj = {
        legend: [],
        xData: [],
        series: [],
        unit: 'kWh',
      }
      let columns = [
        {
          prop: 'measureName',
          label: '测量点',
          fixed: 'left',
          width: 230,
          show: true,
          align: 'left',
        },
        {
          prop: 'time',
          label: '时间类型',
          fixed: 'left',
          width: 230,
          show: true,
          align: 'left',
        },
        {
          prop: 'nTotal',
          fixed: 'left',
          label: '合计',
          width: 110,
          show: true,
          align: 'right',
        },
      ]
      let tableData = []
      if (res.success) {
        res.data.echartsData[0].workOn.forEach((item) => {
          obj.xData.push(vm.matchTime(item.time))
        })
        for (let i = 0; i < res.data.echartsData.length; i++) {
          let item = res.data.echartsData[i]
          let date = null
          if (vm.selectedDate.dateType == 'day') {
            date = item.date.substring(0, 11)
          } else if (vm.selectedDate.dateType == 'month') {
            date = item.date.substring(0, 7)
          } else {
            date = item.date.substring(0, 4) + '年'
          }
          obj.series.push({
            data: [],
            type: 'bar',
            stack: item.measureName + date,
            name: item.measureName + date + '上班',
          })
          obj.legend.push(item.measureName + date + '上班')
          obj.series.push({
            data: [],
            type: 'bar',
            stack: item.measureName + date,
            name: item.measureName + date + '下班',
          })
          obj.legend.push(item.measureName + date + '下班')
          for (let j = 0; j < item.workOn.length; j++) {
            let temp = item.workOn[j]
            obj.series[i * 2].data.push(Number(temp.value).toFixed(2))
          }
          for (let j = 0; j < item.workOff.length; j++) {
            let temp = item.workOff[j]
            obj.series[i * 2 + 1].data.push(Number(temp.value).toFixed(2))
          }
        }
        if (res.data.tableData.length > 0) {
          for (let i = 0; i < res.data.tableData[0].columns.length; i++) {
            let item = res.data.tableData[0].columns[i]
            item = vm.matchTime(item)
            columns.push({
              prop: item,
              label: item,
              show: true,
              width: 110,
              align: 'right',
            })
          }
        }

        for (let i = 0; i < res.data.tableData.length; i++) {
          let item = res.data.tableData[i]
          let date = null
          if (vm.selectedDate.dateType == 'day') {
            date = item.date.substring(0, 11)
          } else if (vm.selectedDate.dateType == 'month') {
            date = item.date.substring(0, 7)
          } else {
            date = item.date.substring(0, 4) + '年'
          }
          for (const key in item.data) {
            item.data[key] = Number(item.data[key]).toFixed(2)
            if (key != 'nTotal') {
              let newKey = vm.matchTime(key) /* 新key格式 */
              let val = item.data[key]
              delete item.data[key]
              item.data[newKey] = val
            }
          }
          tableData.push(item.data)
          tableData[i]['measureName'] = item.measureName
          tableData[i]['time'] = date
        }
      }
      this.echartsData = obj
      this.columns = columns
      vm.tableData = tableData
    },
    /* 匹配时间格式相同的表格 */
    matchTime (item) {
      if (this.selectedDate.dateType == 'day') {
        item = dateTool.format(new Date(item), 'hh时')
      } else if (this.selectedDate.dateType == 'month') {
        item = dateTool.format(new Date(item), 'dd日')
      } else if (this.selectedDate.dateType == 'year') {
        item = dateTool.format(new Date(item), 'MM月')
      }
      return item
    },
  },
}
</script>
<style  scoped lang="scss">
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
}
.box1 {
  padding: 5px;
  box-sizing: border-box;
  color: #2e3842;
  margin-bottom: 14px;
}
.tab-pane {
  width: 100%;
  height: calc(100% - 142px);
  border-radius: 4px;
  .tap-echarts {
    height: 78%;
    margin-bottom: 14px;
    .tab-top {
      height: 45px;
      line-height: 45px;
      padding: 0 14px;
      box-sizing: border-box;
      text-align: left;
      color: #fff;
      font-size: 20px;
      border-radius: 4px 4px 0px 0px;
    }
    .tap-center {
      width: 100%;
      height: calc(100% - 45px);
      .echarts {
        height: 100%;
        width: 100%;
      }
    }
  }
  .tables {
    height: calc(22% - 14px);
    width: 100%;
  }
}
.dbTime {
  color: #000;
  padding: 7px 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  border-radius: 4px;
  .jg {
    margin-right: 10px;
  }
}
.flex {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex1 {
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
</style>